/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_prediction_algorithm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prediction Algorithm`)
};

const es_f1_apex_prediction_algorithm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algoritmo de Predicción`)
};

const de_f1_apex_prediction_algorithm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prognose-Algorithmus`)
};

const nl_f1_apex_prediction_algorithm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorspellingsalgoritme`)
};

const fr_f1_apex_prediction_algorithm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algorithme de prédiction`)
};

const it_f1_apex_prediction_algorithm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algoritmo di previsione`)
};

const pt_br2_f1_apex_prediction_algorithm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algoritmo de previsão`)
};

const pt_f1_apex_prediction_algorithm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algoritmo de previsão`)
};

const ja_f1_apex_prediction_algorithm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予測アルゴリズム`)
};

const zh_f1_apex_prediction_algorithm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预测算法`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_prediction_algorithm = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_prediction_algorithm(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_prediction_algorithm", locale)
	if (locale === "en") return en_f1_apex_prediction_algorithm(inputs)
	if (locale === "es") return es_f1_apex_prediction_algorithm(inputs)
	if (locale === "de") return de_f1_apex_prediction_algorithm(inputs)
	if (locale === "nl") return nl_f1_apex_prediction_algorithm(inputs)
	if (locale === "fr") return fr_f1_apex_prediction_algorithm(inputs)
	if (locale === "it") return it_f1_apex_prediction_algorithm(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_prediction_algorithm(inputs)
	if (locale === "pt") return pt_f1_apex_prediction_algorithm(inputs)
	if (locale === "ja") return ja_f1_apex_prediction_algorithm(inputs)
	return zh_f1_apex_prediction_algorithm(inputs)
};